export enum WalletPaymentTypeEnum {
  CREDIT = "CREDIT",
  WITHDRAW = "WITHDRAW",
}

export enum WalletStatusEnum {
  ACTIVE = 1,
  DISABLED = 2,
}
